/** @jsxRuntime automatic */
/** @jsxImportSource react */
import type { LucideIcon } from 'lucide-react';

/** Icon sizes on the 4 px grid. Lucide line icons, inline SVG, 1.75 stroke (the mockups' weight). */
const SIZES = { xs: 12, sm: 14, md: 16, lg: 20 } as const;
export type IconSize = keyof typeof SIZES;

export interface IconProps {
  icon: LucideIcon;
  size?: IconSize;
  className?: string;
  /** A name for an icon that stands alone; without it the icon is decoration and hidden from assistive tech. */
  label?: string;
}

export function Icon({ icon: Glyph, size = 'md', className, label }: IconProps) {
  return (
    <Glyph
      size={SIZES[size]}
      strokeWidth={1.75}
      className={className ? `ui-icon ${className}` : 'ui-icon'}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
    />
  );
}
